// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import { createStore, createHook } from '@atlassian/react-sweet-state';
import { actions } from './actions/index.tsx';
import type { State } from './types.tsx';

const initialState: State = {};

type Actions = typeof actions;

const store = createStore<State, Actions>({
	name: 'jwm-quickstart-is-sample-project',
	initialState,
	actions,
});

export const useIsSampleProjectService = createHook(store);
